export function is_allowed(permissions = {}, user_type, module = '', action = ''){
//    console.log(permissions, user_type)
    if (user_type == 2){
        
    return permissions[module]?.includes(action) || false;
    }
    else{
        return true
    }
}